"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _endpoints = require("../endpoints");
var _promiseCache = _interopRequireDefault(require("../utils/promise-cache"));
var _fetchWithAuth = _interopRequireDefault(require("../utils/fetch-with-auth"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const DEFAULT_LOCALE = 'en-US';
function CMXService(authState) {
  const fetch = new _fetchWithAuth.default(authState);
  const cache = new _promiseCache.default(authState);
  async function getBundle(bundleName, locales) {
    return await cache(`getBundle:${bundleName}:${locales.join(':')}`, async () => {
      const res = await fetch(`${_endpoints.cmxURL}/bundle/${encodeURIComponent(bundleName)}`, {
        method: 'POST',
        headers: {
          'content-type': 'application/json'
        },
        body: JSON.stringify({
          locales
        })
      });
      const data = await res.json();
      if (res.ok) {
        return data;
      } else {
        throw data;
      }
    })();
  }
  async function getMergedBundle(bundleNames, locale = DEFAULT_LOCALE) {
    const bundleData = await Promise.all(bundleNames.map(bundleName => getBundle(bundleName, [locale])));
    let mergedBundle = bundleData[0].bundles[locale];
    for (let i = 1; i < bundleData.length; i++) {
      mergedBundle = {
        ...mergedBundle,
        ...bundleData[i].bundles[locale]
      };
    }
    return mergedBundle;
  }
  async function getStringsWithAttributes(bundleName, locale = DEFAULT_LOCALE, keys = []) {
    return await cache(`getStringsWithAttributes:${bundleName}:${locale}`, async () => {
      const res = await fetch(`${_endpoints.cmxURL}/projects/${encodeURIComponent(bundleName)}/locales/${locale}/attributes`, {
        method: 'POST',
        headers: {
          'content-type': 'application/json'
        },
        body: JSON.stringify({
          keys
        })
      });
      const data = await res.json();
      if (res.ok) {
        return data;
      } else {
        throw data;
      }
    })();
  }
  return {
    getBundle: getMergedBundle,
    getStringsWithAttributes
  };
}
var _default = exports.default = CMXService;
//# sourceMappingURL=cmx.js.map